import type { MetaFunction } from "react-router";
import NotFound from "@/pages/NotFound";

export const meta: MetaFunction = () => {
  return [
    { title: "Page Not Found - Arcitext" },
    {
      name: "description",
      content: "The page you're looking for doesn't exist.",
    },
  ];
};

export default function CatchAll() {
  return <NotFound />;
}
